import styled from 'styled-components';

const DesktopContainer = styled.div`
  margin: 100px 0 50px 0;

  .in-page-features-v4--featured-content {
    align-items: center;
    display: flex;
  }

  .ant-row {
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
  }
`;

export { DesktopContainer };
